import { SET_ACTIVE_FORM } from "../../constants";
import { getCustomerInformationFromLocalStorage } from "../../selectors";

import { createAction } from "../../utils";

const setActiveForm = createAction(SET_ACTIVE_FORM);

export const setActiveFormInLocalStorage =
  (formType) => (dispatch, getState) => {
    const customerData = getCustomerInformationFromLocalStorage(getState());

    const dataToStore = {
      ...customerData,
      activeForm: formType,
    };

    window.localStorage.setItem(
      "customerInformation",
      JSON.stringify(dataToStore),
    );

    dispatch(setActiveForm(formType));
  };
